import React from "react";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import ModalMobile from "../../../../components/shared/Modal/ModalMobile";

export function ForesightPaymentSuccess({ isOpen, onClose }) {
  return (
    <ModalMobile
      className="p-5 font-manrope w-full max-w-[393px] flex flex-col gap-4"
      isOpen={true}
      onClose={onClose}
      showClose={false}
    >
      <img
        className="w-full"
        src="/images/logos/foresight_integration_large.png"
      />
      <div className="flex flex-col items-center">
        <div className="flex items-center justify-center rounded-full size-10 min-w-10 bg-success50">
          <div className="flex items-center justify-center rounded-full size-8 min-w-8 bg-success100">
            <IoIosCheckmarkCircleOutline className="size-5 min-w-5 text-success500" />
          </div>
        </div>

        <div className="text-xl text-black font-semibold">You are all set</div>
        <div className="text-base text-black">
          Start training now with your Foresight device
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="rounded-full bg-gray100 size-8 min-w-8 flex items-center justify-center">
          1
        </div>
        <div className="text-base text-black">
          Sign in to the app with your account
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="rounded-full bg-gray100 size-8 min-w-8 flex items-center justify-center">
          2
        </div>
        <div className="text-base text-black">
          Start a swing monitor session
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="rounded-full bg-gray100 size-8 min-w-8 flex items-center justify-center">
          3
        </div>
        <div className="text-base text-black">
          Pair your device with Sportsbox app
        </div>
      </div>

      <button
        onClick={onClose}
        className="w-full btnPrimary500 min-h-11 h-11 rounded-full"
      >
        Back to plan
      </button>
    </ModalMobile>
  );
}
